import decoImgs from "../../assets/deco-imgs";
import { animatedImg1, animatedImg2 } from "../../assets/animatedImgs";

const images = [
  decoImgs[24],
  Math.random() > 0.5 ? decoImgs[73] : decoImgs[52],
  animatedImg1,
  decoImgs[64],
  decoImgs[60],
  animatedImg2,
  // decoImgs[68],
  decoImgs[30],
  decoImgs[49],
  decoImgs[11],
  decoImgs[74],
  decoImgs[2],
  decoImgs[59],
  decoImgs[5],
  decoImgs[27],
  decoImgs[48],
  decoImgs[61],
  decoImgs[40],
  decoImgs[22],
  decoImgs[25],
  decoImgs[47],
  decoImgs[26],
  decoImgs[4],
  decoImgs[23],
  decoImgs[9],
  decoImgs[51],
  decoImgs[55],
  decoImgs[28],
  decoImgs[67],
  decoImgs[7],
  decoImgs[29],
  decoImgs[35],
  decoImgs[8],
  decoImgs[19],
  decoImgs[10],
  decoImgs[6],
  decoImgs[1],
  decoImgs[3],
  decoImgs[12],
  decoImgs[13],
  decoImgs[16],
  decoImgs[17],
  decoImgs[50],
  decoImgs[20],
  decoImgs[21],
  decoImgs[31],
  decoImgs[32],
  decoImgs[33],
  decoImgs[36],
  decoImgs[38],
  decoImgs[39],
  decoImgs[18],
  decoImgs[41],
  decoImgs[42],
  decoImgs[43],
  decoImgs[45],
  decoImgs[44],
  decoImgs[56],
  decoImgs[46],
  decoImgs[57],
  decoImgs[58],
  decoImgs[62],
  decoImgs[63],
  decoImgs[65],
  decoImgs[66],
  decoImgs[69],
  decoImgs[72],
  decoImgs[70],
  decoImgs[71],
  decoImgs[54],
  decoImgs[34],
  decoImgs[53],
  decoImgs[37],
];

export default images;
